<template>
  <div class="">
    <div class="update_wrap">
        <div class="update_info">
                <span>
                    刷新时间：{{nowDate}}
                </span>
                <img src="../../assets/img/update_btn.png" @click="getData" alt="">
            </div>
        </div>
        <table class="ivu-table table m-t-10" cellspacing="0" cellpadding="0" style="height:auto">
            <tr>
                <th v-for="(tab,$index) in list" :key="$index" :class="list.length == 1?'textC':''">
                    <span class="ivu-table-cell">{{tab.pointName}}({{tab.unit}})</span>
                </th>
            </tr>
            <tr>
                <td v-for="(tab,$index) in list" :key="$index" :class="list.length == 1?'textC':''">
                    <span class="ivu-table-cell">{{tab.value}}</span>
                </td>
            </tr>
        </table>
        <div class="textRight m-t-10" style="background:linear-gradient(90deg, rgb(69, 161, 205) 0px, rgb(4 25 54) 30%);">
            <span class="fLeft lh32" v-if="type=='dl'">电流历史数据</span>
            <span class="fLeft lh32" v-if="type=='sd'">湿度历史数据</span>
            <span class="fLeft lh32" v-if="type=='wd'">温度历史数据</span>
        </div>
        <line-chart class="m-t-10" :id="'line-chart-0'" :height="'240px'" :y="lineData.y" :x="lineData.x"></line-chart>
  </div>
</template>
<script>
import lineChart from '@/components/line.vue';
import { getDate } from '@/assets/js/index.js';
// 随机字符串
import getRandVal, {getTime} from '@/assets/js/index';
// 加密
import Base64 from '@/assets/js/base64.js';
import md5 from 'js-md5';
export default {
  name:"",    
  data: () => ({
    nowDate: null,
    loadValue: {},
    list: [],
    lineData: {
        x: [],
        y: []
    },
    loginData: {},
  }),
  props: ['partId','type'],
  components: {
      lineChart
  },
  created() {

  },
  mounted() {
    this.getData();
    this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
  },
  computed: {

  },
  methods: {
    //获取数据开始
    getPwdHash(pwd, data) {
        var sha = md5(pwd + data);
        var base = new Base64();
        var pwdHashStr = base.encode(sha);
        return pwdHashStr;
    },
    getData(){
        this.nowDate = getDate(new Date().getTime(), 'year');
        this.loadValue = {};
        this.list = [];
        this.lineData = {
            x: [],
            y: []
        }

        let url = '/mcbw/network_monitor/graph/' + this.partId;
        let _this = this;
        var data = {
            type: 'get',
            url: url,
            obj: {
                orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                type: this.type,
            }
        };
        _this.$Axios(data).then((res)=>{
            if(res.data.success){
                let arrX = [], arrY = {}, index = 0;
                for (let item in res.data.data) {
                    let obj = res.data.data[item];
                    console.log(obj);
                    for (let y = 0; y < obj.length; y++) {
                        if (index === 0) arrX.push(obj[y]['time'].substring(11,19));
                        if (arrY[item] && arrY[item].length) {
                            arrY[item].push(obj[y]['value'])
                        } else {
                            arrY[item] = [obj[y]['value']];
                        }
                    }
                    if (arrX.length) index = 1;
                }
                // let translate = {
                //     '今日': arrY.today,
                //     '昨日': arrY.yesterday,
                // }
                
                this.lineData['x'] = arrX;
                this.lineData['y'] = arrY;
            }
        });
        
        this.getHead();
    },
    getHead(){
        //获取头部表格数据
        let url = '/mcbw/network_monitor/pointNowValue/' + this.partId;
        let _this = this;
        var data = {
            type: 'get',
            url: url,
            obj: {
                orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                type: this.type
            }
        };
        _this.$Axios(data).then((res)=>{
            if(res.data.success){
                this.list = res.data.data;
            }
        });
    },
    
  }
}
</script>
<style lang="scss" scoped>
/deep/ .ivu-table th,
/deep/ .ivu-table td{
    text-align: center;
} 
table{
    width: 100%
}
.update_wrap{
    display: flex;
    justify-content: flex-end;
    .update_info{
        display: flex;
        align-items: center;
        justify-content: space-between;
        span{
            margin-right: 10px;
        }
        img{
            width: 16px;
            height: 16px;
            cursor: pointer;
        }
        // button{
        //     margin-left: 10px;
        // }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/zdmh/dl.vue